import { HpQueryValueMap } from '@avantia/client-and-server-utilities';
import { getAnswersAction as getEngineAnswersAction } from '../engineClient/actions/getAnswersAction';
import { HpGetAnswersActionPayload } from '../engineClient/actions/getAnswersActionTypes';
import { HpDispatchFunction } from '../engineClient/types';

// eslint-disable-next-line @typescript-eslint/ban-types
export function getAnswersAction(
  props: HpGetAnswersActionPayload
): (dispatch: HpDispatchFunction<any>) => Promise<void> {
  const queryParams: HpQueryValueMap = {};
  const args: HpGetAnswersActionPayload = {
    ...props,
    queryParams
  };

  return getEngineAnswersAction(args);
}
